<template>
  <div class="input-group tag-search">
    <multiselect
      v-model="selected"
      label="name"
      track-by="id"
      :placeholder="placeholder"
      open-direction="bottom"
      :options="options"
      :taggable="false"
      :searchable="true"
      :internal-search="false"
      :multiple="true"
      :show-labels="false"
      :loading="isLoading"
      :options-limit="300"
      :max-height="600"
      selected-label=""
      select-label=""
      deselect-label=""
      @input="onSelect"
      @open="openSearch"
      @search-change="asyncFindOrm"
    >
      <span
        slot="caret"
        class="icon-search"
      >
        <i
          class="fa fa-search"
          aria-hidden="true"
        />
      </span>
    </multiselect>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import multiselect from 'vue-multiselect';
import Tag from '@/vuex/orm/fetcher/admin/models/Tag';

import { mapState, mapActions, mapGetters } from 'vuex';

import { sync } from 'vuex-pathify';

export default {
  components: {
    multiselect,
  },

  data() {
    return {
      selected: null,
      options: [],
      isLoading: false,
      placeholder: this.$i18n.t('JSON.search'),
    };
  },

  computed: {
    ...sync([
      'filter.siteId',
      'filter.selectedTags',
    ]),

    ...mapState({
      tags: (state) => state.tag.tags,
    }),
  },

  watch: {
    selectedTags: {
      handler(selectedTags) {
        this.selected = this.selectedTags;
      },
      deep: true,
    },
  },

  mounted() {
    if (this.selectedTags.length > 0) {
      // console.log('selectedTags', this.selectedTags);
      this.selected = this.selectedTags;
    }
  },

  methods: {
    ...mapActions(['getTags']),

    onSelect(option) {
      // console.log('VideoTags.onSelect.option', option);
      // console.log('VideoTags.onSelect.selected', this.selected);
      Bus.$emit('tags_selected', this.selected);
    },

    openSearch() {
      this.options = [];
    },

    // async asyncFindApi(query) {
    //   if (query.length >= 3) {
    //     // console.log(query);
    //     this.options = [];
    //     try {
    //       this.isLoading = true;
    //       await this.getTags({
    //         params: {
    //           siteId: this.siteId,
    //         },
    //       });
    //       // success
    //       console.log('success querying tags!', this.tags);
    //       this.options = this.tags;
    //       this.isLoading = false;
    //     } catch (error) {
    //       // error
    //       console.log('error querying tags!');
    //     }
    //   }
    // },
    async asyncFindOrm(query) {
      if (query.length >= 1) {
        this.options = Tag.query()
          .where('name', (value) => value.toLowerCase().includes(query.toLowerCase()))
          .orWhere('slug', (value) => value.toLowerCase().includes(query.toLowerCase()))
          .get();
      } else {
        this.options = [];
      }
    },
  },
};
</script>

<style scoped>
.input-group {
  display: inline-block;
}
</style>
